import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

export const useDeletePendingDirectDataImport = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (pendingDirectDataImportId) => {
      const { data } = await axios.delete(
        `/api/content/deletePendingDirectDataImport/${pendingDirectDataImportId}`
      );
      return data;
    },
    {
      // Invalidate here (hook-level) rather than at the mutate() call sites:
      // mutate-level callbacks are dropped if the calling component unmounts
      // before the request settles — which is exactly what happens when a
      // resumed import succeeds and the import modal closes itself. Hook-level
      // callbacks still run, so the Pending Imports list refreshes reliably.
      onSettled: () =>
        queryClient.invalidateQueries("pendingDirectDataImports"),
    }
  );
};
